module.exports = __webpack_public_path__ + "img/engi-small.cd5f40a3.jpg";